import React, { useEffect, useState } from 'react';
import { Box, Card, CardActions, CardContent, Divider, IconButton, InputLabel, List, ListItem, OutlinedInput, Typography, useTheme } from '@mui/material';
import DocTabs from './DocTabs';
import { MainContainer, MainHeading, ParaText } from '../../style/GlobalStyles';
import { useNavigate, useParams } from 'react-router-dom';
import { BusinessDocumentsDetails, MainData, MEMBER_DETAILS } from '../../contants/MyCompaniesConstant';
import { useAuth } from '../../hooks/useAuth';
import { DocsSkeleton, MemberSkeleton } from './skeleton';
import { post } from '../../api';
import { LoadingButton } from '@mui/lab';
import Modal from '../../components/Modal';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { CustomChip } from '../../components/CustomChip';
import { SERVICE_STATUS } from '../../contants/PrimeAccountServicesPageConstant';
import CustomTooltip from '../../components/CustomTooltip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

function MyCompanies() {
    const [currentCompanyDetails, setCurrentCompanyDetails] = useState(null);
    const params = useParams();
    const theme = useTheme();
    const { getUserDetailsNotAsync, setUserDetailsNotAsync, refreshSessionData } = useAuth();
    const userDetails = getUserDetailsNotAsync();
    const navigate = useNavigate();

    const [companyDetails, setCompanyDetails] = useState([]);

    const [s3Files, setS3Files] = useState([]);
    const [row, setRow] = useState({});
    const successStatus = ['Active', 'Sent to Customer'];
    const errorStatus = ['Needs Attention', 'Inactive'];
    const [loading, setLoading] = useState(false);
    const [isInviteModalOpen, setIsInviteModalOpen] = useState(false);
    const [inviteContact, setInviteContact] = useState(null);
    const inviteContactRef = React.useRef(null);

    const formatSalesforceDate = (utcDateString) => {
        if (!utcDateString) return '';

        const [year, month, day] = utcDateString.split('T')[0].split('-');
        const date = new Date(Date.UTC(year, month - 1, day));

        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: '2-digit',
            timeZone: 'UTC',
        });
    };

    function formatStatusText(text) {
        if (!text) return '';
        return text
            .toLowerCase()
            .split(' ')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    }

    const isValidEIN = (str) => /^\d{2}-\d{7}$/.test(str.trim());

    const getCompanyDetailsFn = (hideRenewals) => {
        const cCompanyData = userDetails?.businessList.find((cCompany) => cCompany.id === params.id);
        setCompanyDetails(
            [
                [
                    {
                        name: 'Company',
                        value: cCompanyData?.accountName || 'Pending',
                    },
                    {
                        name: 'State of Incorporation',
                        value: cCompanyData?.entityState || 'Pending',
                    },
                ],
                [
                    {
                        name: 'Date of Incorporation',
                        value: cCompanyData?.entityApprovalDate ? formatSalesforceDate(cCompanyData.entityApprovalDate) : 'Pending',
                    },
                    {
                        name: hideRenewals ? '' : 'Renewal Date',
                        value: hideRenewals ? '' : cCompanyData?.entityRenewalDate ? formatSalesforceDate(cCompanyData.entityRenewalDate) : 'Pending',
                    },
                ],
                [
                    {
                        name: 'Employer Identification Number (EIN)',
                        value: cCompanyData?.einNumber && isValidEIN(cCompanyData?.einNumber) ? cCompanyData?.einNumber : 'Pending',
                    },
                    cCompanyData?.activeRAPProductCount > 0 && {
                        name: 'Registered Agent',
                        value: 'Prime Corporate Services',
                    },
                ],
            ].filter(Boolean)
        );
    };

    useEffect(() => {
        const cCompanyData = userDetails?.businessList.find((cCompany) => cCompany.id === params.id);
        setCurrentCompanyDetails(cCompanyData);
        setLoading(true);

        if (true) {
            post('document/getRelatedRecordsProtected', { recordId: cCompanyData?.accountId }).then((result) => {
                if (result.isSuccess) {
                    setS3Files(result.data);
                }
            });

            post('custom/getCompanyDetails', { recordId: cCompanyData?.accountId }).then((result) => {
                if (result.isSuccess) {
                    cCompanyData.serverDetails = result.data;
                    setCurrentCompanyDetails(cCompanyData);
                    userDetails.businessList = userDetails?.businessList.map((company) => {
                        if (company.id === cCompanyData.id) {
                            return cCompanyData;
                        }
                        return company;
                    });
                    setUserDetailsNotAsync(userDetails);

                    if (result.data.displayRenewal) {
                        getCompanyDetailsFn(false);
                    }
                }

                setLoading(false);
            });
            post('custom/getEntityFormationService', { accountId: cCompanyData?.accountId }).then((result) => {
                if (result.isSuccess) {
                    setRow(result.data);
                }
            });
        }

        console.log('cCompanyDatacCompanyDatacCompanyDatacCompanyData', cCompanyData);

        getCompanyDetailsFn(true);
    }, [params.id]);

    // if (loading) {
    //     return skeleton;
    // }

    if (!currentCompanyDetails) {
        return null;
    }

    const getActions = () => {
        let customerLabels = [
            { label: 'Amendment', value: 'Biz Help' },
            { label: 'Dissolution', value: 'Biz Help' },
            { label: 'Billing', value: 'Billing' },
            { label: 'Renewal', value: 'Renewals' },
            { label: 'Other', value: 'Support' },
        ];
        return [
            {
                name: 'Billing history',
                onClick: () => navigateToURL(`/payment-information/billing-history?filter=${currentCompanyDetails.accountId}`),
            },
            {
                name: 'View mailbox',
                onClick: () => navigateToURL(`/mail?filter=${currentCompanyDetails.accountId}`),
            },
            {
                name: 'Amend entity',
                onClick: () =>
                    createCase({
                        title: `Request support—Entity Formation`,
                        subTitle: 'Tell us a little more about how we can help you and an agent will contact you shortly!',
                        subject: `Request support: Entity Formation`,
                        companyName: currentCompanyDetails.accountName,
                        recordType: 'General Case',
                        accountId: currentCompanyDetails.accountId,
                        showCustomerField: Boolean(customerLabels), // show customer field
                        customerLabelList: customerLabels,
                        type: 'Amendment',
                    }),
            },
            {
                name: 'Dissolve entity',
                onClick: () =>
                    createCase({
                        title: `Request support—Entity Formation`,
                        subTitle: 'Tell us a little more about how we can help you and an agent will contact you shortly!',
                        subject: `Request support: Entity Formation`,
                        companyName: currentCompanyDetails.accountName,
                        recordType: 'General Case',
                        accountId: currentCompanyDetails.accountId,
                        showCustomerField: Boolean(customerLabels), // show customer field
                        customerLabelList: customerLabels,
                        type: 'Dissolution',
                    }),
            },
        ];
    };

    const createCase = (detail) => {
        const event = new CustomEvent('createCase', {
            detail: detail,
        });

        document.dispatchEvent(event);
    };

    const navigateToURL = (url) => {
        navigate(url);
    };

    const getDocuments = () => {
        if (currentCompanyDetails?.serverDetails?.files?.length > 0) {
            let mapCategory = {};
            let records = currentCompanyDetails.serverDetails.files;
            if (records) {
                records = [...records, ...s3Files];
                let newRecords = records.filter((item) => {
                    let title = item.title || item.Title;
                    if (title.toLowerCase().indexOf('exceptions - prime') === -1) {
                        return true;
                    }
                    return false;
                });
                records = newRecords;
            }

            for (let file of records) {
                file.category = file.category || file.Category || 'Others';
                if (!mapCategory[file.category]) {
                    mapCategory[file.category] = { label: file.category, value: file.category, files: [] };
                }
                mapCategory[file.category].files.push(file);
            }

            const mapCategoryList = Object.values(mapCategory) || [];

            mapCategoryList.sort((a, b) => {
                if (a.value === 'Entity Documents') return -1;
                if (b.value === 'Entity Documents') return 1;
                return 0;
            });

            return mapCategoryList;
        }
        return [];
    };

    const handleInvite = (cDetails) => {
        inviteContactRef.current = cDetails;
        if (!cDetails.email) {
            setIsInviteModalOpen(true);
        } else {
            saveInvite();
        }
    };

    const saveInvite = () => {
        let messageDetail = { variant: 'success', message: 'Invitation sent successfully' };
        const event = new CustomEvent('openToster', {
            detail: messageDetail,
        });

        document.dispatchEvent(event);
        setIsInviteModalOpen(false);

        const cCompanyData = userDetails?.businessList.find((cCompany) => cCompany.id === params.id);
        cCompanyData.serverDetails.contacts = cCompanyData.serverDetails.contacts.map((item) => {
            if (item.id === inviteContactRef.current?.id) {
                item.sendPortalInvite = true;
                item.email = inviteContactRef.current.email;
            }
            return item;
        });
        userDetails.businessList = userDetails?.businessList.map((company) => {
            if (company.id === cCompanyData.id) {
                return cCompanyData;
            }
            return company;
        });
        setCurrentCompanyDetails({ ...cCompanyData });
        setUserDetailsNotAsync(userDetails);

        post('custom/inviteContact', { contact: inviteContactRef.current }).then((result) => {
            if (!result.isSuccess) {
                console.log('Error in sending invitation');
            }
            inviteContactRef.current = null;
        });
    };

    const handleInviteModalOnSuccess = (data) => {
        console.log(data);
        setIsInviteModalOpen(false);
        saveInvite();
    };

    const handleEmailChange = (value) => {
        inviteContactRef.current = { ...inviteContactRef.current, email: value };
    };

    console.log('companyDetails', companyDetails);

    return (
        <MainContainer>
            <MainHeading sx={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                <Box>{currentCompanyDetails.accountName}</Box>
                <Box sx={{ marginTop: '-3px' }}>
                    {row?.customerFacingStatus && (
                        <CustomChip
                            variant="outlined"
                            color={successStatus.indexOf(row?.customerFacingStatus) > -1 ? 'success' : errorStatus.indexOf(row?.customerFacingStatus) > -1 ? 'error' : 'warning'}
                            label={formatStatusText(row?.customerFacingStatus)}
                            style={row?.customerFacingStatus === 'Inactive' ? { border: `1px solid lightgray` } : {}}
                            sx={(theme) => ({
                                ...(row?.customerFacingStatus === SERVICE_STATUS?.notfiled
                                    ? {
                                          border: `1px solid ${theme.palette.text.tertiary}`,
                                          background: 'transparent',
                                      }
                                    : row?.customerFacingStatus === SERVICE_STATUS?.suggested
                                      ? {
                                            border: `1px solid ${theme.palette.border.neutralSecondary}`,
                                            background: 'transparent',
                                        }
                                      : null),
                            })}
                        />
                    )}
                    {row?.description && (
                        <CustomTooltip title={row.description}>
                            <IconButton
                                sx={(theme) => ({
                                    marginLeft: '0.25rem',
                                    color: 'gray.900',
                                    padding: 0,

                                    // '& svg': {
                                    //     width: '18px',
                                    //     height: '18px',
                                    // },
                                })}
                            >
                                <InfoOutlinedIcon fontSize="small" />
                            </IconButton>
                        </CustomTooltip>
                    )}
                </Box>
            </MainHeading>
            <ParaText marginTop={theme.typography.generic.xSmall}>{MainData.para}</ParaText>

            <Divider
                sx={{
                    margin: `${theme.typography.generic.xxxxxLarge} 0`,
                }}
            />

            <Box
            // sx={{
            //     marginTop: `${theme.typography.generic.xLarge}`,
            // }}
            >
                <Card>
                    <CardContent sx={{ padding: '16px 24px' }}>
                        <Box
                            display={'flex'}
                            flexDirection={{
                                xs: 'column',
                                sm: 'column',
                                md: 'row',
                            }}
                        >
                            <Box
                                display={'flex'}
                                rowGap={{
                                    xs: '1.5rem',
                                    sm: '2rem',
                                }}
                                flexDirection={{
                                    xs: 'column',
                                    sm: 'row',
                                }}
                                flexWrap={'wrap'}
                                width={{
                                    xs: 'unset',
                                    md: '100%',
                                }}
                            >
                                {companyDetails.map((column, index) => (
                                    <Box
                                        key={index}
                                        width={{
                                            xs: '100%',
                                            sm: '33%',
                                            md: '33%',
                                        }}
                                        display={'flex'}
                                        flexDirection={'column'}
                                        gap={'1rem'}
                                    >
                                        {column.map((cCompanyDetails) => (
                                            <Box>
                                                <Typography component={'p'} variant="paraText4" color="gray.700">
                                                    {cCompanyDetails.name}
                                                </Typography>
                                                <Typography component={'p'} variant="paraText1" color="text.secondary">
                                                    {cCompanyDetails.value}
                                                    {cCompanyDetails.name === 'Employer Identification Number (EIN)' && cCompanyDetails.value !== 'Pending' && (
                                                        <IconButton
                                                            sx={{
                                                                transform: 'translateY(-2px)',
                                                                marginLeft: '1px',
                                                            }}
                                                            onClick={() => {
                                                                navigator.clipboard
                                                                    .writeText(cCompanyDetails.value)
                                                                    .then(() => {
                                                                        const event = new CustomEvent('openToster', {
                                                                            detail: {
                                                                                message: 'EIN copied',
                                                                                autoHideDuration: 1500,
                                                                            },
                                                                        });
                                                                        document.dispatchEvent(event);
                                                                    })
                                                                    .catch((err) => console.error('Failed to copy: ', err));
                                                            }}
                                                        >
                                                            <ContentCopyIcon
                                                                sx={{
                                                                    fontSize: '14px',
                                                                }}
                                                            />
                                                        </IconButton>
                                                    )}
                                                </Typography>
                                            </Box>
                                        ))}
                                    </Box>
                                ))}
                            </Box>
                            {/* <Box
                                width={{
                                    xs: 'unset',
                                    md: '50%',
                                }}
                                marginTop={{
                                    xs: theme.typography.generic.xxxxxLarge,
                                    md: theme.typography.generic.unset,
                                }}
                                paddingLeft={{ md: '1rem' }}
                            >
                                <Typography color={'text.neutralSecondary'} fontSize={'customFontSize.small'} fontWeight={'fontWeightRegular'} lineHeight={1.4}>
                                    {MEMBER_DETAILS.name}
                                </Typography>

                                {!loading
                                    ? currentCompanyDetails?.serverDetails?.contacts?.map((cDetails, index) => (
                                          <Typography key={index} color={'text.secondary'} fontSize={'customFontSize.mediam'} fontWeight={'fontWeightSemiBold'} lineHeight={1.5}>
                                              <span style={{ textTransform: 'capitalize' }}>{cDetails.name}</span>

                                              {cDetails.id && (
                                                  <span>
                                                      {' - '}
                                                      {!cDetails.sendPortalInvite && cDetails.email !== userDetails.contact.email ? (
                                                          <Typography onClick={() => handleInvite(cDetails)} component={'span'} variant="paraText1" color={'primary.main'} sx={{ cursor: 'pointer' }}>
                                                              Invite
                                                          </Typography>
                                                      ) : (
                                                          <>
                                                              {cDetails.email !== userDetails.contact.email && (
                                                                  <Typography component={'span'} variant="paraText1" color={'text.tertiary'}>
                                                                      Invited
                                                                  </Typography>
                                                              )}
                                                          </>
                                                      )}
                                                      {cDetails.email === userDetails.contact.email ? (
                                                          <Typography component={'span'} variant="paraText1" color={'text.tertiary'}>
                                                              (You)
                                                          </Typography>
                                                      ) : (
                                                          ''
                                                      )}
                                                  </span>
                                              )}
                                          </Typography>
                                      ))
                                    : MemberSkeleton}
                            </Box> */}
                        </Box>
                    </CardContent>

                    <Divider />

                    <CardActions sx={{ padding: '24px 24px 16px' }}>
                        <Box width={'100%'}>
                            <Typography component={'p'} variant="paraText1">
                                Manage Entity
                            </Typography>
                            <List
                                sx={{
                                    display: 'flex',
                                    marginLeft: '-16px',
                                    // padding:0,
                                    flexWrap: {
                                        xs: 'wrap',
                                        md: 'nowrap',
                                    },
                                    overflow: 'auto',

                                    '@media (min-width:1000px)': {
                                        justifyContent: 'space-between !important',
                                    },
                                }}
                            >
                                {getActions().map((cListItem) => (
                                    <ListItem
                                        key={cListItem.name}
                                        sx={{
                                            width: '100%',
                                            '@media (min-width:500px)': {
                                                width: '50%',
                                            },

                                            '@media (min-width:601px)': {
                                                width: '100%',
                                            },

                                            '@media (min-width:790px)': {
                                                width: '50%',
                                            },
                                            '@media (min-width:1000px)': {
                                                width: 'auto !important',
                                            },
                                        }}
                                        onClick={cListItem.onClick}
                                    >
                                        <Typography
                                            color={'primary.main'}
                                            variant="paraText1"
                                            lineHeight={1}
                                            sx={{
                                                cursor: 'pointer',
                                                '@media (min-width:300px)': {
                                                    whiteSpace: 'nowrap',
                                                },
                                            }}
                                        >
                                            {cListItem.name}
                                        </Typography>
                                    </ListItem>
                                ))}
                            </List>
                        </Box>
                    </CardActions>
                </Card>
            </Box>
            {!loading
                ? currentCompanyDetails?.serverDetails?.files?.length > 0 && (
                      <Box
                          sx={{
                              marginTop: `2.25rem`,
                          }}
                      >
                          <Typography
                              component={'h3'}
                              variant="heading3"
                              color={'text.primary'}
                              sx={{
                                  marginBottom: `${theme.typography.generic.xSmall}`,
                              }}
                          >
                              {BusinessDocumentsDetails.heading}
                          </Typography>
                          <DocTabs categories={getDocuments()} />
                      </Box>
                  )
                : DocsSkeleton}

            <Modal
                modalOpen={isInviteModalOpen}
                title="Update Email"
                hideActions={false}
                handleModalClose={() => setIsInviteModalOpen(false)}
                handleModalOnSuccess={handleInviteModalOnSuccess}
                submitBtnProps={{
                    disabled: inviteContact?.email === '',
                }}
                SubmitBtnUI={
                    <LoadingButton loading={loading} disabled={inviteContact?.email === ''} type="button" variant="contained" onClick={handleInviteModalOnSuccess}>
                        Save & Invite
                    </LoadingButton>
                }
            >
                <Box
                    component="form"
                    display={'flex'}
                    flexDirection={'column'}
                    onSubmit={undefined}
                    noValidate
                    sx={{
                        gap: {
                            sm: '1.25rem',
                            xs: '0.75rem',
                        },
                    }}
                >
                    <Box display={'flex'} flexDirection={'column'} gap={theme.typography.generic.xxSmall} width={'100%'}>
                        <InputLabel htmlFor="email">Email Address</InputLabel>
                        <OutlinedInput id="email" type="email" name="email" onChange={(event) => handleEmailChange(event.target.value)} placeholder="Enter Email Address" />
                    </Box>
                </Box>
            </Modal>
        </MainContainer>
    );
}

export default MyCompanies;
